import {useAxiosClient} from "~/use/axios/client";
import {GmModelLibraryModelsAccountModel, ManagerApi} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {useOnline} from "@vueuse/core";

export const useManagerService = () => {
    const { axiosClient } = useAxiosClient()
    const managerApi = new ManagerApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()

    const managersQueryOptions: UseQueryOptions<GmModelLibraryModelsAccountModel[]> = {
        queryKey: ['managerGetManagers'],
        queryFn: async () => {
            return (await managerApi.managerGetManagers())?.data
        },
        staleTime: MS_HOUR,
        refetchOnWindowFocus: false,
        networkMode: 'offlineFirst',
        placeholderData: keepPreviousData,
        enabled: isOnline,
        gcTime: Infinity,
    }

    const managersQuery = () => useQuery(managersQueryOptions)

    return {
        managersQueryOptions,
        managersQuery,
    }
}